export const ActionTypes = {
    UNMOUNT_LOGIN:'UNMOUNT_LOGIN',

    LOGIN: 'LOGIN',
    LOGIN_PENDING: 'LOGIN_PENDING',
    LOGIN_FULFILLED: 'LOGIN_FULFILLED',
    LOGIN_REJECTED: 'LOGIN_REJECTED',

    FIRST_LOGIN: 'FIRST_LOGIN',
    FIRST_LOGIN_PENDING: 'FIRST_LOGIN_PENDING',
    FIRST_LOGIN_FULFILLED: 'FIRST_LOGIN_FULFILLED',
    FIRST_LOGIN_REJECTED: 'FIRST_LOGIN_REJECTED',

    START_SECOND_FACTOR: 'START_SECOND_FACTOR',
    DO_SECOND_FACTOR: 'DO_SECOND_FACTOR',
    DO_SECOND_FACTOR_PENDING: 'DO_SECOND_FACTOR_PENDING',
    DO_SECOND_FACTOR_FULFILLED: 'DO_SECOND_FACTOR_FULFILLED',
    DO_SECOND_FACTOR_REJECTED: 'DO_SECOND_FACTOR_REJECTED',

    RESET_PASSWORD: 'RESET_PASSWORD',
    RESET_PASSWORD_PENDING: 'RESET_PASSWORD_PENDING',
    RESET_PASSWORD_FULFILLED: 'RESET_PASSWORD_FULFILLED',
    RESET_PASSWORD_REJECTED: 'RESET_PASSWORD_REJECTED',
};

type baseHeader = {
    Accept: string;
    'Cache-Control': string;
    'Content-Type': string;
}

export const BASE_HEADER: baseHeader = {
    'Accept': 'application/json',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json'
}
